module.exports = __webpack_public_path__ + "img/stars.34169c86.svg";